import {
  INITIATED_REFUNDS,
  BATCH_REFUNDS,
  AUTO_REFUNDS,
  CHECKBOX,
} from './constants';

import {
  REFUNDS_STATUS_ITEMS,
  BATCH_REFUNDS_STATUS_ITEMS,
  AUTO_REFUNDS_STATUS_ITEMS,
  AUTO_REFUNDS_PAYMENT_MODE_ITEMS,
  AUTO_REFUNDS_TYPE_ITEMS,
} from '../../../utils/constants';

export default {
  [INITIATED_REFUNDS]: {
    TABLE_COLUMNS: [
      {
        key: 'refundId',
        displayName: 'Refund ID',
        width: 0.1,
      },
      {
        key: 'refundAmount',
        displayName: 'Refund Amt.',
        width: 0.1,
        align: 'right',
      },
      {
        key: 'refundSpeed',
        displayName: 'Refund Speed',
        width: 0.3,
      },
      {
        key: 'refundAddedOn',
        displayName: 'Processed at',
        sortable: true,
        width: 0.3,
        tooltip: {
          message: 'Refund Added On',
        },
      },
      {
        key: 'paymentMode',
        displayName: 'Payment Method',
        width: 0.3,
      },
      {
        key: 'orderId',
        displayName: 'Order ID',
        width: 0.5,
      },
      {
        key: 'refundStatus',
        displayName: 'Status',
        width: 0.5,
      },
    ],
    FILTER_ITEMS: {
      status: {
        displayText: 'Status',
        type: CHECKBOX,
        items: REFUNDS_STATUS_ITEMS,
      },
    },
    SEARCH_ITEMS: [
      {
        key: 'orderId',
        text: 'Order ID',
        value: 'orderId',
        placeholder: 'Ex: Order ID 1, Order ID 2',
        inputPattern: '^[\\|\\w\\d ,.-]+$',
        error:
          'Only alphanumeric and special characters (space, comma, dot, hyphen) are allowed.',
      },
      {
        key: 'transactionId',
        text: 'Transaction ID',
        value: 'txId',
        placeholder: 'Ex: Transaction ID 1, Transaction ID 2',
        inputPattern: '^[0-9,]+$',
        error: 'Only numbers and comma are allowed.',
      },
      {
        key: 'phoneNumber',
        text: 'Phone Number',
        value: 'customerPhone',
        placeholder: 'Enter Phone Number',
        inputPattern: '^[0-9 +-]+$',
        maxLength: 14,
        error:
          'Only numbers and special characters (space, plus, hyphen) are allowed.',
      },
      {
        key: 'refundId',
        text: 'Refund ID',
        value: 'refundId',
        placeholder: 'Enter Refund ID',
        inputPattern: '^[a-zA-Z0-9_-]+$',
        error:
          'Only alphanumeric and special characters (underscore, hyphen) are allowed.',
      },
      {
        key: 'cfRefundId',
        text: 'CF Refund ID',
        value: 'cfRefundId',
        placeholder: 'Enter CF Refund ID',
        inputPattern: '^[0-9]+$',
        error: 'Only numbers are allowed',
      },
      {
        key: 'refundArn',
        text: 'Refund ARN',
        value: 'arn',
        placeholder: 'Enter Refund ARN',
        inputPattern: '^[a-zA-Z0-9_-]+$',
        error:
          'Only alphanumeric and special characters (underscore, hyphen) are allowed.',
      },
      {
        key: 'email',
        text: 'Email ID',
        value: 'customerEmail',
        placeholder: 'Enter Email ID',
      },
    ],
  },
  [BATCH_REFUNDS]: {
    TABLE_COLUMNS: [
      {
        key: '_id',
        displayName: 'Batch Refund ID',
        width: 0.6,
      },
      {
        key: 'merchantFileName',
        displayName: 'File Name',
        width: 0.6,
      },
      {
        key: 'createdAt',
        displayName: 'Uploaded At',
        sortable: true,
        width: 0.5,
        tooltip: {
          message: 'Batch File Added On',
        },
      },
      {
        key: 'countSuccessful',
        displayName: 'Refunds Processed',
        width: 0.5,
      },
      {
        key: 'countTotal',
        displayName: 'Records Uploaded',
        width: 0.5,
      },
      {
        key: 'fileStatus',
        displayName: 'Status',
        width: 0.1,
      },
      {
        key: 'batchRefundsCta',
        displayName: '',
        align: 'right',
        pin: 'right',
        width: 0.01,
      },
    ],
    FILTER_ITEMS: {
      fileStatus: {
        displayText: 'Status',
        type: CHECKBOX,
        items: BATCH_REFUNDS_STATUS_ITEMS,
      },
    },
    SEARCH_ITEMS: [
      {
        key: 'batchFileId',
        text: 'Batch ID',
        value: 'fileId',
        placeholder: 'Enter Batch ID',
        inputPattern: '^[a-zA-Z0-9_-]+$',
        error:
          'Only alphanumeric and special characters (underscore, hyphen) are allowed.',
      },
      {
        key: 'fileName',
        text: 'File Name',
        value: 'merchantFileName',
        placeholder: 'Enter File Name',
      },
    ],
  },
  [AUTO_REFUNDS]: {
    TABLE_COLUMNS: [
      {
        key: 'reversalId',
        displayName: 'Refund ID',
        width: 0.05,
      },
      {
        key: 'reversalAmount',
        displayName: 'Refund Amt.',
        width: 0.05,
        align: 'right',
      },
      {
        key: 'orderAmount',
        displayName: 'Order Amt.',
        width: 0.1,
        align: 'right',
      },
      {
        key: 'addedOnAuto',
        displayName: 'Processed at',
        width: 0.14,
        sortable: true,
        tooltip: {
          message: 'Refund Added On',
        },
      },
      {
        key: 'orderId',
        displayName: 'Order ID',
        width: 0.12,
      },
      {
        key: 'paymentMode',
        displayName: 'Payment Method',
        width: 0.2,
      },
      {
        key: 'userVisibleStatus',
        displayName: 'Status',
        width: 0.08,
      },
    ],
    FILTER_ITEMS: {
      reversalStatus: {
        displayText: 'Status',
        type: CHECKBOX,
        items: AUTO_REFUNDS_STATUS_ITEMS,
      },
      paymentMode: {
        displayText: 'Payment Mode',
        type: CHECKBOX,
        items: AUTO_REFUNDS_PAYMENT_MODE_ITEMS,
      },
      reversalType: {
        displayText: 'Type',
        type: CHECKBOX,
        items: AUTO_REFUNDS_TYPE_ITEMS,
      },
    },
    SEARCH_ITEMS: [
      {
        key: 'orderId',
        text: 'Order ID',
        value: 'orderId',
        placeholder: 'Enter CF Order ID',
        inputPattern: '^[a-zA-Z0-9_-]+$',
        error:
          'Only alphanumeric and special characters (underscore, hyphen) are allowed.',
      },
      {
        key: 'transactionId',
        text: 'Transaction ID',
        value: 'transactionId',
        placeholder: 'Ex: Transaction ID 1, Transaction ID 2',
        inputPattern: '^[0-9,]+$',
        error: 'Only numbers and comma are allowed.',
      },
      {
        key: 'reversalId',
        text: 'Refund ID',
        value: 'reversalId',
        placeholder: 'Enter Refund ID',
        inputPattern: '^[0-9,]+$',
        error: 'Only numbers and comma are allowed.',
      },
      {
        key: 'txRef',
        text: 'Transaction UTR',
        value: 'txRef',
        placeholder: 'Ex: Transaction UTR 1, Transaction UTR 2',
        inputPattern: '^[a-zA-Z0-9_-]+$',
        error:
          'Only alphanumeric and special characters (underscore, hyphen) are allowed.',
      },
      {
        key: 'customerPhone',
        text: 'Phone Number',
        value: 'customerPhone',
        placeholder: 'Enter Phone Number',
        inputPattern: '^[0-9 +-]+$',
        maxLength: 14,
        error:
          'Only numbers and special characters (space, plus, hyphen) are allowed.',
      },
      {
        key: 'customerEmail',
        text: 'Email ID',
        value: 'customerEmail',
        placeholder: 'Enter Email ID',
      },
    ],
  },
};
